module.exports = __webpack_public_path__ + "img/km.c2368be2.jpg";